import React from 'react'

import { ToolbarButton, useMediaQueryContext } from '@fourthwall/components'
import type { ToolbarButtonProps } from '@fourthwall/components/dist/common/ToolbarButton/types'
import { BotIcon } from '@fourthwall/icons'

import { useAIKitDashboard } from '../AIKitDashboardProvider'

type ChatbotToolbarButtonProps = {
  iconSize?: ToolbarButtonProps['iconSize']
}

export const ChatbotToolbarButton = ({ iconSize = 18 }: ChatbotToolbarButtonProps) => {
  const { toggleChatbot, isChatbotEnabled } = useAIKitDashboard()
  const mq = useMediaQueryContext()

  if (!isChatbotEnabled) {
    return null
  }

  // Hide on mobile (show from tablet and up)
  if (!mq.tablet) {
    return null
  }

  // NOTE: This will be moved to @modules/chatbot
  return (
    <ToolbarButton
      label="AI Assistant"
      icon={BotIcon}
      iconSize={iconSize}
      onClick={toggleChatbot}
    />
  )
}
